import React, { useMemo } from 'react'

function AsteroidBelt() {
  const asteroids = useMemo(() => {
    const temp = [];
    for (let i = 0; i < 200; i++) {
      const angle = (i / 200) * Math.PI * 2;
      const radius = 6 + Math.random() * 1.5;
      const x = Math.cos(angle) * radius;
      const z = Math.sin(angle) * radius;
      const y = (Math.random() - 0.5) * 0.5;
      const size = 0.01 + Math.random() * 0.02;
      
      temp.push({
        position: [x, y, z],
        size,
        rotation: [Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI]
      });
    }
    return temp;
  }, []);

  return (
    <group>
      {asteroids.map((asteroid, index) => (
        <mesh key={index} position={asteroid.position} rotation={asteroid.rotation} castShadow receiveShadow>
          <dodecahedronGeometry args={[asteroid.size]} />
          <meshStandardMaterial color="#8C7853" roughness={0.9} />
        </mesh>
      ))}
    </group>
  );
}

export default AsteroidBelt